import { render, staticRenderFns } from "./RechargeSuccess.vue?vue&type=template&id=48fd0bdd&scoped=true&"
import script from "./RechargeSuccess.vue?vue&type=script&lang=js&"
export * from "./RechargeSuccess.vue?vue&type=script&lang=js&"
import style0 from "./RechargeSuccess.vue?vue&type=style&index=0&id=48fd0bdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd0bdd",
  null
  
)

export default component.exports